import PageAbstract from '../PageAbastract'

export default class AirBookingVessel extends PageAbstract {
  constructor(job, formData) {
    super(job, formData)
  }

  async loadElement(elementName) {
    let e = null
    switch (elementName) {
      case 'voyageFlight': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'mbl': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'multiJourneyAirline': {
        e = {
          elementName,
          component: (await import('@/components/uiCustom/ae/vessel/multiJourneyAirline'))?.default,
          props: {}
        }
        const jobCallback = () => { e.props.job = this.job }
        this.joinJobWatchList(jobCallback)
        jobCallback()
        break
      }
      case 'secondFlight': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'secondPodCode': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
      case 'secondPod': {
        e = {
          elementName,
          component: 'el-input',
          disabled: true,
          props: {}
        }
        break
      }
    }
    if (e) {
      this.elementMap.set(elementName, e)
    }
    return e
  }
}
